import React from 'react';
import PropTypes from 'prop-types';
import ErgoDataForm from '../../components/ErgoDataForm';
import { formTypes } from '../../models/form';

const DamageValues = props => (
  <ErgoDataForm {...props} formType={formTypes.DAMAGE_VALUE} />
);

DamageValues.propTypes = {
  localePath: PropTypes.string,
  isValid: PropTypes.bool,
  buttonText: PropTypes.string,
};

DamageValues.defaultProps = {
  localePath: '',
  isValid: true,
  buttonText: '',
};

DamageValues.contextTypes = {
  t: PropTypes.func,
};

export default DamageValues;
